import React, { useCallback, useEffect, useState } from 'react';
import Switch from 'react-switch';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';


import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

import { Container, Wrapper } from './styles';
import PromotionsService from '../../services/PromotionsService';
import { SelectProductsModal } from './SelectProductsModal';
import { Group, Product } from '../../services/GroupsService';

const SCHEDULES: string[] = [];

for (let i = 0; i < 24; i += 1) {
  for (let j = 0; j < 60; j += 15) {
    let hours: string | number = i;
    let minutes: string | number = j;

    if (hours < 10) {
      hours = `0${hours}`;
    }

    if (minutes < 10) {
      minutes = `0${minutes}`;
    }

    SCHEDULES.push(`${hours}:${minutes}`);
  }
}

SCHEDULES.push('23:59');

function moneyMask(value: string): string {
  return (Number(value.replace(/\D/g, '')) / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

const masks = {
  money: moneyMask,
};

export type MaskType = keyof typeof masks;

const CreateFreeDelivery: React.FC = () => {
  const theme = useTheme();
  const history = useHistory();
  const { user, rotinas, findRotinas } = useAuth();
  const { addToast } = useToast();

  const [active, setActive] = useState(true);
  const [isFirstBuy, setIsFirstBuy] = useState(false);
  const [isCumulative, setIsCumulative] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [discountType, setDiscountType] = useState('2');
  const [discountValue, setDiscountValue] = useState('');
  const [minimumValue, setMinimumValue] = useState('');
  const [maximumValue, setMaximumValue] = useState('');

  const [selectedGroups, setSelectedGroups] = useState<Group[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<Product[]>([]);
  const [openModal, setOpenModal] = useState(false);

  const [selectedGroupsSecond, setSelectedGroupsSecond] = useState<Group[]>([]);
  const [selectedProductsSecond, setSelectedProductsSecond] = useState<Product[]>([]);
  const [openModalSecond, setOpenModalSecond] = useState(false);

  function mask(type: MaskType, value: string): string {
    const m = masks[type];
    return m(value);
  }

  function getNumberValue(value = '00,00'): number {
    return parseFloat(
      value
        .toString()
        .replace('R$', '')
        .replace(' ', '')
        .replace('.', '')
        .replace(',', '.'),
    );
  }

  // eslint-disable-next-line consistent-return
  function handleSubmit() {
    try {
      if (!name) {
        return addToast({
          type: 'error',
          title: 'Ocorreu um erro',
          description: 'Insira uma descrição para o cupom',
        });
      }

      if (!description) {
        return addToast({
          type: 'error',
          title: 'Ocorreu um erro',
          description: 'Insira uma descrição para o cupom',
        });
      }

      if (getNumberValue(discountValue) < 0) {
        return addToast({
          type: 'error',
          title: 'Ocorreu um erro',
          description: 'Insira um desconto válido',
        });
      }

      if (getNumberValue(minimumValue) < 0) {
        return addToast({
          type: 'error',
          title: 'Ocorreu um erro',
          description: 'Insira um desconto válido',
        });
      }

      if (getNumberValue(maximumValue) < 0) {
        return addToast({
          type: 'error',
          title: 'Ocorreu um erro',
          description: 'Insira um desconto válido',
        });
      }

      PromotionsService.createPromotion(
        user.empresa_id,
        name,
        description,
        getNumberValue(minimumValue) || 0,
        getNumberValue(maximumValue) || 0,
        Number(discountType),
        discountType === '2' ? 100 : getNumberValue(discountValue) || 0,
        startDate ? `${startDate}T00:00:00` : '',
        endDate ? `${endDate}T23:59:59` : '',
        isFirstBuy,
        true,
        1,
        selectedProducts.map((product) => product.id),
        selectedGroups.map((group) => group.id),
        selectedProductsSecond.map((product) => product.id),
        selectedGroupsSecond.map((group) => group.id),
      ).then((res) => {
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Cupom cadastrado com sucesso',
        });
  
        history.push('/frete-gratis');
      }).catch((error) => {
        addToast({
          type: 'error',
          title: 'Ocorreu um erro',
          description: (error as any).response.data.message || 'Tente novamente',
        });
      })

      
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Ocorreu um erro',
        description: (err as any).response.data.message || 'Tente novamente',
      });
    }
  }

  const hasPermission = useCallback(
    (): boolean => findRotinas('promocoes')?.alterar || false,
    [findRotinas],
  );

  function handleOpenModal() {
    setOpenModal(true);
  }

  function handleCloseModal() {
    setOpenModal(false);
  }

  function handleOpenModalSecond() {
    setOpenModalSecond(true);
  }

  function handleCloseModalSecond() {
    setOpenModalSecond(false);
  }

  useEffect(() => {
    if (rotinas && !hasPermission()) {
      addToast({
        type: 'error',
        title: 'Não autorizado.',
        description: 'Você não tem permissão.',
      });
      history.push('/frete-gratis');
    }
  }, [addToast, hasPermission, history, rotinas]);

  return (
    <Container>
      <Wrapper>
        <header>
          <div>
            <h1>Frete grátis</h1>
            <h3>
              As promoções são aplicadas automaticamente nas compras que atendem as condições delas.
            </h3>
          </div>
          <div style={{ display: 'flex' }}>
            <button
              type="button"
              className="outline"
              onClick={() => history.push('/frete-gratis')}
            >
              <span>Descartar alterações</span>
            </button>
            <button type="button" onClick={handleSubmit}>
              <span>Adicionar</span>
            </button>
          </div>
        </header>
        <main>
          <div className="first-column">
            <div className="inputs-container">
              <h3>Nome da promoção</h3>
              <input
                type="text"
                placeholder="Ex: Frete Grátis na Primeira Compra"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>
            <div className="inputs-container">
              <h3>Descrição da promoção</h3>
              <input
                type="text"
                placeholder="Ex: Na compra de uma pizza o frete é grátis"
                value={description}
                onChange={(event) => setDescription(event.target.value)}
              />
            </div>
            <div className="inputs-container">
              <h3>Configuração da promoção</h3>
              <div className="inputs">
                <div className="input-content half">
                  <label htmlFor="discount_type">Tipo da promoção</label>
                  <select
                    name="discount_type"
                    id="discount_type"
                    value={discountType}
                    onChange={(event) => {
                      setDiscountType(event.target.value);
                      setDiscountValue('');
                    }}
                  >
                    <option value='1'>Valor máximo</option>
                    <option value='2'>100% de desconto</option>
                  </select>
                </div>
                <div className="input-content half">
                  {discountType === '1' && (
                    <>
                      <label htmlFor="discount_value">Valor</label>
                      <div className="input-wrapper">
                        {discountType === '1' || discountType === '3' && <span className="left">R$</span>}
                        <input
                          type={discountType === '1' || discountType === '3' ? 'text' : 'number'}
                          id="discount_value"
                          className="right"
                          value={discountValue}
                          step={1}
                          onChange={(event) => {
                            const { value } = event.target;

                            if (discountType === '1' || discountType === '3') {
                              setDiscountValue(mask('money', value).split(' ')[1]);

                              return;
                            }

                            setDiscountValue(value);
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className="input-content half">
                  <label htmlFor="minimum_value">Compra mínima do pedido</label>
                  <div className="input-wrapper">
                    <span className="left">R$</span>
                    <input
                      type="text"
                      id="minimum_value"
                      className="left"
                      value={minimumValue}
                      onChange={(event) => {
                        const { value } = event.target;

                        setMinimumValue(mask('money', value).split(' ')[1]);
                      }}
                    />
                  </div>
                </div>
                <div className="input-content half">
                  <label htmlFor="minimum_value">Compra máxima do pedido</label>
                  <div className="input-wrapper">
                    <span className="left">R$</span>
                    <input
                      type="text"
                      id="maximum_value"
                      className="left"
                      value={maximumValue}
                      onChange={(event) => {
                        const { value } = event.target;

                        setMaximumValue(mask('money', value).split(' ')[1]);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="inputs-container">
              <h3>Seleção de grupos e produtos</h3>
              <button 
                type="button" 
                onClick={handleOpenModal}
                className='open-selection'
              >
                Abrir seleção
              </button>
              {selectedGroups.map((group) => {
                let products: Product[] = [];

                if(group.products) {
                  const selectedIds = selectedProducts.map((product) => product.id);
                  products = group.products.filter((product) => selectedIds.includes(product.id));
                }

                return (
                  <>
                    <h2 className='group-title'>{group.name}</h2>
                    <ul>
                      {products.map((product) => <li>{product.name}</li>)}
                    </ul>
                  </>
                );
              })}
            </div>

            <div className="inputs-container">
              <h3>Seleção de grupos e produtos secundários</h3>
              <button 
                type="button" 
                onClick={handleOpenModalSecond}
                className='open-selection'
              >
                Abrir seleção
              </button>
              {selectedGroupsSecond.map((group) => {
                let products: Product[] = [];

                if(group.products) {
                  const selectedIds = selectedProductsSecond.map((product) => product.id);
                  products = group.products.filter((product) => selectedIds.includes(product.id));
                }

                return (
                  <>
                    <h2 className='group-title'>{group.name}</h2>
                    <ul>
                      {products.map((product) => <li>{product.name}</li>)}
                    </ul>
                  </>
                );
              })}
            </div>
          </div>
          <div className="second-column">
            <div className="filled-container active">
              <Switch
                checked={active}
                onChange={setActive}
                id="active"
                checkedIcon={false}
                uncheckedIcon={false}
                onColor={theme.colors.main}
                height={16}
                width={35}
                handleDiameter={10}
              />
              <label htmlFor="active">{active ? 'Ativo' : 'Inativo'}</label>
            </div>
            <div className="filled-container active">
              <Switch
                checked={isFirstBuy}
                onChange={setIsFirstBuy}
                id="first-buy"
                checkedIcon={false}
                uncheckedIcon={false}
                onColor={theme.colors.main}
                height={16}
                width={35}
                handleDiameter={10}
              />
              <label htmlFor="first-buy">Primeira Compra</label>
            </div>
            {/* <div className="filled-container active">
              <Switch
                checked={isCumulative}
                onChange={setIsCumulative}
                id="cumulative"
                checkedIcon={false}
                uncheckedIcon={false}
                onColor={theme.colors.main}
                height={16}
                width={35}
                handleDiameter={10}
              />
              <label htmlFor="cumulative">Acumulativa</label>
            </div> */}
            <div className="inputs-container">
              <h3>Data de início</h3>
              <input
                type="date"
                value={startDate}
                onChange={(event) => setStartDate(event.target.value)}
              />
            </div>
            <div className="inputs-container">
              <h3>Data de término</h3>
              <input
                type="date"
                value={endDate}
                onChange={(event) => setEndDate(event.target.value)}
              />
            </div>
          </div>
        </main>
      </Wrapper>

      {openModal && (
        <SelectProductsModal
          open={openModal}
          handleClose={handleCloseModal}
          selectedGroups={selectedGroups}
          selectedProducts={selectedProducts}
          setSelectedGroups={setSelectedGroups}
          setSelectedProducts={setSelectedProducts}
        />
      )}

      {openModalSecond && (
        <SelectProductsModal
          open={openModalSecond}
          handleClose={handleCloseModalSecond}
          selectedGroups={selectedGroupsSecond}
          selectedProducts={selectedProductsSecond}
          setSelectedGroups={setSelectedGroupsSecond}
          setSelectedProducts={setSelectedProductsSecond}
        />
      )}
    </Container>
  );
};

export default CreateFreeDelivery;
